import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import Image from "next/image"
import { slugify } from "@/lib/utils"

export function CategoryCard({
  category,
}: {
  category: { id: number; name: string; handle: string }
}) {
  const categorySlug = slugify(category.handle)
  return (
    <LocalizedClientLink
      href={`/categories/${categorySlug}`}
      className="relative flex flex-col items-center border rounded-sm bg-component transition-all hover:rounded-full w-[233px] aspect-square"
    >
      <div className="flex relative aspect-square overflow-hidden w-[200px]">
        <Image
          src={`/images/categories/${categorySlug}.jpg`}
          alt={category.name}
          width={233}
          height={193}
          className="object-cover scale-90 rounded-full"
        />
      </div>
      <h3 className="w-full text-center label-lg text-primary">
        {category.name}
      </h3>
    </LocalizedClientLink>
  )
}
